<template>
  <div>
    <div id="map" style="height: 500px; width: 100%"></div>
    <div class="filters">
      <select v-model="selectedType" @change="filterLocations">
        <option value="">Alla</option>
        <option value="rundelsgatan">Rundelsgatan</option>
        <option value="dockplatsen">Dockplatsen</option>
        <option value="florettgatan">Florettgatan</option>
      </select>
    </div>
  </div>
</template>

<script>
import { Loader } from "@googlemaps/js-api-loader";
import { MarkerClusterer } from "@googlemaps/markerclusterer";

export default {
  props: {
    selectedPlaces: {
      type: Array,
      required: true,
    },
    selectedTypesOfBuildings: {
      type: Array,
      required: true,
    },
    minSize: {
      type: String,
    },
    maxSize: {
      type: String,
    },
    objects: {
      type: Array,
      default: () => [
        { latitude: 55.604981, longitude: 13.003822 },
        { latitude: 55.604981, longitude: 13.003822 },
        { latitude: 55.604981, longitude: 13.003822 },
        { latitude: 55.604981, longitude: 13.003822 },
        { latitude: 55.604981, longitude: 13.003822 },
        { latitude: 55.604981, longitude: 13.003822 },
      ],
    },
    apiKey: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      map: null,
      AdvancedMarkerElement: null,
      markers: [],
      advancedMarkers: [],
      locations: [
        {
          id: 1,
          type: "rundelsgatan",
          lat: 55.604981,
          lng: 13.003822,
          title: "Rundelsgatan",
        },
        {
          id: 2,
          type: "dockplatsen",
          lat: 55.607981,
          lng: 13.003822,
          title: "Dockplatsen 12",
        },
        {
          id: 3,
          type: "florettgatan",
          lat: 55.605981,
          lng: 13.003822,
          title: "Florettgatan 14",
        },
      ],
      markerCluster: null,
      selectedType: "",
      currentInfoWindow: null,
      filterObjects: [],
    };
  },
  methods: {
    async initMap() {
      const loader = new Loader({
        apiKey: this.apiKey,
        version: "weekly",
      });

      try {
        const { Map } = await loader.importLibrary("maps");
        const { AdvancedMarkerElement } = await loader.importLibrary("marker");

        this.AdvancedMarkerElement = AdvancedMarkerElement;

        this.map = new google.maps.Map(document.getElementById("map"), {
          zoom: 9,
          mapId: "4a7f481b039dddba",
          clickableIcons: false,
        });
        this.filterObjects = this.objects.filter(this.isValidCoordinate);

        this.addMarkers();
        this.fitMapToMarkers();
        google.maps.event.addListener(this.map, "zoom_changed", () => {
          const currentZoom = this.map.getZoom();
          if (currentZoom >= 16) {
            this.refreshMarkerCluster();
          }
        });
      } catch (error) {
        console.error("Error loading Google Maps");
      }
    },
    isValidCoordinate(obj) {
      return (
        obj.latitude !== null &&
        obj.longitude !== null &&
        obj.latitude !== 0.0 &&
        obj.longitude !== 0.0
      );
    },
    addMarkers() {
      this.clearMarkers();
      this.clearMarkerClusterer();
      this.createMarkerClusterer();
    },

    /**create markers and marker-clusters*/
    createMarkerClusterer() {
      const groupedMarkers = this.groupMarkersByPosition(this.filterObjects);
      const markers = [];
      groupedMarkers.forEach((group, key) => {
        const [lat, lng] = key.split(",").map(Number);
        const count = group.length;
        const markerContent = document.createElement("div");
        let isInfoWindowOpen = false;

        markerContent.className = "custom-cluster";
        markerContent.innerHTML = `<span>${count} </span>`;

        const marker = new this.AdvancedMarkerElement({
          position: { lat, lng },
          map: this.map,
          content: markerContent,
        });
        marker.data = group;

        const infoWindow = new google.maps.InfoWindow();
        // Add an event listener for the close button in the InfoWindow

        google.maps.event.addListener(infoWindow, "closeclick", () => {
          this.currentInfoWindow = null;
          isInfoWindowOpen = false;
        });

        marker.addListener("gmp-click", () => {
          const zoomLevel = this.map.getZoom();
          const minZoomForInfoWindows = 12;

          if (zoomLevel >= minZoomForInfoWindows) {
            if (this.currentInfoWindow) {
              this.currentInfoWindow.close();
            }

            this.currentInfoWindow = infoWindow;

            this.currentInfoWindow.open(this.map, marker);
            isInfoWindowOpen = true;
            this.showSlideshow(group);
          }
        });

        //below hover on marker code can be introduced later if needed

        // // Open on hover

        // marker.addEventListener("mouseover", () => {
        //   if (!isInfoWindowOpen) {
        //     const zoomLevel = this.map.getZoom();
        //     const minZoomForInfoWindows = 12;

        //     if (zoomLevel >= minZoomForInfoWindows) {
        //       if (this.currentInfoWindow) {
        //         this.currentInfoWindow.close();
        //       }
        //       this.currentInfoWindow = infoWindow;
        //       this.currentInfoWindow.open(this.map, marker);

        //       this.showSlideshow(group);
        //     }
        //   }
        // });

        // // Close InfoWindow on mouseout **only if it wasn't clicked**
        // marker.addEventListener("mouseout", () => {
        //   if (!isInfoWindowOpen) {
        //     // Only close if it wasn't clicked
        //     if (this.currentInfoWindow) {
        //       this.currentInfoWindow.close();
        //       this.currentInfoWindow = null;
        //     }
        //   }
        // });

        this.map.addListener("click", () => {
          if (this.currentInfoWindow) {
            this.currentInfoWindow.close();
            isInfoWindowOpen = false;
          }
        });
        markers.push(marker);
      });
      this.advancedMarkers = markers;
      this.markerCluster = new MarkerClusterer({
        markers: markers,
        map: this.map,
        renderer: {
          render: ({ count, position, markers }) => {
            // Calculate the total number of properties/items in the cluster
            var totalPropertyCount = markers.reduce(function (sum, item) {
              return (
                sum + (item.data && item.data.length ? item.data.length : 0)
              );
            }, 0);
            const clusterMarkerContent = document.createElement("div");
            clusterMarkerContent.className = "custom-cluster";
            clusterMarkerContent.innerHTML = `<span>${totalPropertyCount}</span>`;
            return new this.AdvancedMarkerElement({
              map: this.map,
              position,
              content: clusterMarkerContent,
            });
          },
        },
      });

      this.markerCluster.addListener("click", (event) => {
        if (this.currentInfoWindow) {
          this.currentInfoWindow.close();
        }
      });
    },
    /**create single or multiple modal-slide show with object data */
    showSlideshow(group) {
      let currentIndex = 0;

      const updateInfoWindowContent = () => {
        let obj = group[currentIndex];
        const contentString = `
        <div class="info-window-container">
          <div class="info-window-image-wrapper">
            <img src="${
              obj.image ? obj.image.imgSrc : "/gui/images/fastighet.png"
            }" alt="Property Image" class="info-window-image" />
          </div>
          <div class="info-window-details">
            <h3 class="info-window-title">
              <a href="${window.location.origin}${obj.url}">
                ${obj.title}
              </a>
            </h3>
            <p class="info-window-address">${obj.address}</p>
           ${
             obj.sizeFrom || obj.sizeTo
               ? `<p class="info-window-size">
            ${
              obj.sizeFrom && obj.sizeTo
                ? obj.sizeFrom !== obj.sizeTo
                  ? `${obj.sizeFrom} - ${obj.sizeTo}`
                  : obj.sizeFrom
                : obj.sizeFrom || obj.sizeTo
            } m²
          </p>`
               : ""
           }
            <div class="info-window-premises">
              ${obj.premiseType
                .map(
                  (premise) =>
                    `<span class="c-object__icon-wrapper">${premise}</span>`
                )
                .join("")}
            </div>
          </div>
          ${
            group.length > 1
              ? `<div class="info-window-carousel-controls">
              <button id="prevButton" ${
                currentIndex === 0 ? "disabled" : ""
              }>&lt;</button>
              <span>${currentIndex + 1} / ${group.length}</span>
              <button id="nextButton" ${
                currentIndex === group.length - 1 ? "disabled" : ""
              }>&gt;</button>
            </div>`
              : ""
          }
          </div>
          `;

        this.currentInfoWindow.setContent(contentString);
        if (group.length > 1) {
          google.maps.event.addListenerOnce(
            this.currentInfoWindow,
            "domready",
            () => {
              document
                .getElementById("prevButton")
                .addEventListener("click", () => {
                  currentIndex =
                    (currentIndex - 1 + group.length) % group.length;
                  updateInfoWindowContent();
                });
              document
                .getElementById("nextButton")
                .addEventListener("click", () => {
                  currentIndex = (currentIndex + 1) % group.length;
                  updateInfoWindowContent();
                });
            }
          );
        }
      };
      updateInfoWindowContent();
    },

    /**before creating markers we group them based on the co-ordinates */
    groupMarkersByPosition(filteredLocations) {
      const groupedMarkers = new Map();

      filteredLocations.forEach((location) => {
        const key = `${location.latitude},${location.longitude}`;

        if (!groupedMarkers.has(key)) {
          groupedMarkers.set(key, []);
        }
        groupedMarkers.get(key).push(location);
      });
      return groupedMarkers;
    },

    refreshMarkerCluster() {
      this.clearMarkerClusterer();
      this.markerCluster = new MarkerClusterer({
        markers: this.advancedMarkers,
        map: this.map,
        renderer: {
          render: ({ count, position, markers }) => {
            // Calculate the total number of properties/items in the cluster
            const totalPropertyCount = markers.reduce(function (sum, item) {
              return (
                sum + (item.data && item.data.length ? item.data.length : 0)
              );
            }, 0);
            const clusterMarkerContent = document.createElement("div");
            clusterMarkerContent.className = "custom-cluster";
            clusterMarkerContent.innerHTML = `<span>${totalPropertyCount}</span>`;
            return new this.AdvancedMarkerElement({
              map: this.map,
              position,
              content: clusterMarkerContent,
            });
          },
        },
      });

      this.markerCluster.addListener("click", (event) => {
        if (this.currentInfoWindow) {
          this.currentInfoWindow.close();
        }
      });
    },

    /**center the map based on marker co-ordinates */
    fitMapToMarkers() {
      if (!this.map || this.advancedMarkers.length === 0) return;

      const bounds = new google.maps.LatLngBounds();

      this.advancedMarkers.forEach((marker) => {
        if (marker.position) {
          bounds.extend(marker.position);
        }
      });

      this.map.fitBounds(bounds);

      google.maps.event.addListenerOnce(this.map, "bounds_changed", () => {
        let zoom = this.map.getZoom();

        if (zoom < 9) {
          this.map.setZoom(9);
        } else if (zoom > 12) {
          this.map.setZoom(12);
        }
      });
    },

    filterLocations() {
      this.clearMarkers();
      this.clearMarkerClusterer();

      this.filterObjects =
        this.selectedPlaces.length > 0
          ? this.objects.filter((location) =>
              this.selectedPlaces.includes(location.type)
            )
          : this.objects;

      this.addMarkers();
    },
    filterPremiseType() {
      this.clearMarkers();
      this.clearMarkerClusterer();

      this.filterObjects =
        this.selectedTypesOfBuildings.length > 0
          ? this.objects.filter((premiseType) =>
              this.selectedTypesOfBuildings.includes(premiseType.type)
            )
          : this.objects;

      this.addMarkers();
    },
    filterSize() {
      this.clearMarkers();
      this.clearMarkerClusterer();

      this.filterObjects = this.objects;
      if (this.minSize !== "") {
        filteredLocations = this.objects.filter(
          (object) =>
            object.sizeFrom >= parseInt(this.minSize) ||
            object.sizeTo >= parseInt(this.minSize)
        );
      }
      if (this.maxSize !== "") {
        filteredLocations = this.objects.filter(
          (object) =>
            object.sizeTo <= parseInt(this.maxSize) ||
            object.sizeFrom <= parseInt(this.maxSize)
        );
      }

      this.addMarkers();
    },

    clearMarkers() {
      if (this.markers) {
        this.markers.forEach((marker) => {
          marker.setMap(null);
        });
        this.markers = [];
      }
      if (this.advancedMarkers) {
        this.advancedMarkers.forEach((advancedMarker) => {
          advancedMarker.setMap(null);
        });
        this.advancedMarkers = [];
      }
    },
    clearMarkerClusterer() {
      if (this.markerCluster) {
        this.markerCluster.clearMarkers();
        this.markerCluster = null;
      }
    },
  },
  watch: {
    objects: {
      immediate: false,
      handler(newObjects) {
        if (newObjects) {
          this.initMap();
        }
      },
    },
    selectedPlaces() {
      this.filterLocations();
    },
    selectedTypesOfBuildings() {
      this.filterPremiseType();
    },
    minSize() {
      this.filterSize();
    },
    maxSize() {
      this.filterSize();
    },
  },
  mounted() {
    if (this.objects) {
      this.initMap();
    }
  },
};
</script>
